import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import MainContainer from "../../components/container/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  getProjectReportById,
  unsetSelectedProject,
} from "../../features/projectsSlice";
import Loading from "../../components/loading/Loading";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const SingleProjectReport = () => {
  const dispatch = useDispatch();
  const { location } = useLocation();
  const projectReport = useSelector((state) => state.projects.selected);
  const load = useSelector((state) => state.projects.load.getProjectReportById);
  const { id } = useParams();

  const milestones = projectReport.milestones ? projectReport.milestones : [];

  useEffect(() => {
    dispatch(getProjectReportById(id));
    return () => {
      dispatch(unsetSelectedProject());
    };
  }, []);

  if (load === loadStatus.loading) {
    return <Loading />;
  }

  if (load === loadStatus.loading) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer className="text-text-1">
      <h3>
        {projectReport.status?.toLowerCase() === "upcoming"
          ? projectReport.name
          : projectReport.title || projectReport.name}
        - Report
      </h3>
      {milestones.length > 0 &&
        milestones.map((mile) => (
          <div key={mile.id} className="mt-4">
            <h5 className="bg-primary/80  text-text-gen p-3 rounded-md">
              {mile.name}
            </h5>
            <div className="px-4">
              {mile.tasks.map((task) => (
                <div key={task.id}>
                  <h5 className="text-text-1/85">{task.name}</h5>
                  <div>
                    {task.subtasks &&
                      task.subtasks.map((sub) => (
                        <div
                          key={sub.id}
                          className="border border-bkg2/75 rounded-md p-6 mb-5"
                        >
                          <h5 className="text-text-1/80">{sub.name}</h5>
                          <p className="text-text-1/70">{sub.description}</p>
                          <div className=" ">
                            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
                              {sub.images.map((image) => (
                                <div key={image.id} className="flex-1">
                                  <img
                                    crossOrigin="anonymous"
                                    className="w-full object-cover h-full"
                                    src={`${image.image_url}`}
                                    // src="localhost:3500/files/1728656567990-652718581-error401.png"
                                    alt="Image"
                                  />
                                </div>
                              ))}
                            </div>
                            {sub.documents.map((doc) => (
                              <div key={doc.id}>
                                <p>{doc.doc_url}</p>
                                <p>{doc.type}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      {milestones.length <= 0 && (
        <div className="h-96 border-2 border-bkg2 rounded-md mt-5 flex items-center justify-center">
          <h4 className="text-text-1/60">Project yet to be started...</h4>
        </div>
      )}
    </MainContainer>
  );
};

export default SingleProjectReport;
